import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import BottomNavigation from '@material-ui/core/BottomNavigation'
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction'
import InfoIcon from '@material-ui/icons/Info'
import Visibility from '@material-ui/icons/Visibility'
import ViewModuleIcon from '@material-ui/icons/ViewModule'
// import Variable from 'mdi-material-ui/Variable'
import Create from '@material-ui/icons/Create'
import { clickBottomNavigation } from 'actions/template'
import { last } from 'lodash'
import styles from './styles'
import Hidden from '@material-ui/core/Hidden'

export default connect(
  state => ({
    bottomNavigation: state.email.bottomNavigation,
    selectedAction: state.tasks.addOrEdit.fields.selectedActionPrediction.value,
    emailCardSelected: last(state.email.cardSelected),
    stepper: state.view.stepper?.template,
    sectionSelected: state.email.sectionSelected,
  }),
  dispatch => bindActionCreators({ clickBottomNavigation }, dispatch),
)(
  withStyles(styles)(
    ({
      clickBottomNavigation,
      bottomNavigation,
      selectedAction,
      emailCardSelected,
      stepper,
      classes,
      sectionSelected,
      modal,
    }) => (
      <Hidden mdUp>
        <BottomNavigation
          className={modal ? classes.bottomNavModal : classes.bottomNav}
          onChange={clickBottomNavigation}
          value={bottomNavigation}
          showLabels
          style={{
            display: stepper === 1 ? 'flex' : 'none',
          }}
        >
          <BottomNavigationAction
            classes={{
              selected: classes.bottomNavActionSelected,
              label: classes.bottomNavLabel,
            }}
            label="Preview"
            icon={<Visibility style={{ color: '#fff' }} />}
          />
          {typeof sectionSelected === 'number' && (
            <BottomNavigationAction
              classes={{
                root: classes.bottomNavEditor,
                selected: classes.bottomNavEditorSelected,
                label: classes.bottomNavLabel,
              }}
              label="Editor"
              icon={<Create style={{ color: '#fff' }} />}
            />
          )}
          <BottomNavigationAction
            classes={{
              selected: classes.bottomNavActionSelected,
              label: classes.bottomNavLabel,
            }}
            label="General"
            icon={<InfoIcon style={{ color: '#fff' }} />}
          />
          {emailCardSelected !== 'sms' && (
            <BottomNavigationAction
              classes={{
                selected: classes.bottomNavActionSelected,
                label: classes.bottomNavLabel,
              }}
              label="Snippets"
              icon={<ViewModuleIcon style={{ color: '#fff' }} />}
            />
          )}
          {/* <BottomNavigationAction
            classes={{
              selected: classes.bottomNavActionSelected,
              label: classes.bottomNavLabel,
            }}
            label="Variables"
            icon={<Variable style={{ color: '#fff' }} />}
          /> */}
        </BottomNavigation>
      </Hidden>
    ),
  ),
)
